import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "booking-basic-info" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  for: "bookingDescription",
  class: "form-label"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 2,
  class: "invalid-feedback"
}

import { computed } from 'vue';
import { useMasterDataHelpers } from '../composables/useMasterDataHelpers.js';
import { TITLE_MAX_LENGTH, DESCRIPTION_MAX_LENGTH } from '../../services/validationMessages.js';
import CharacterLimitedField from './CharacterLimitedField.vue';


export default {
  __name: 'BookingBasicInfo',
  props: {
	form: {
		type: Object,
		required: true,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	mode: {
		type: String,
		default: 'create',
	},
	booking: {
		type: Object,
		default: null,
	},
	titleValidator: {
		type: Object,
		default: null,
	},
	descriptionValidator: {
		type: Object,
		default: null,
	},
},
  setup(__props) {

const props = __props;

// Extract the form instance for easier access in template
const { form } = props;

// Get master data helpers
const { getBookingTypeById, userRole } = useMasterDataHelpers();

// Check if we're in view mode
const isViewMode = computed(() => props.mode === 'view');

// Get current booking type for display in view mode
const currentBookingType = computed(() => {
	if (!isViewMode.value || !props.booking?.bookingTypeId) {
		return null;
	}
	return getBookingTypeById.value(props.booking.bookingTypeId);
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Booking Type Display (view mode only) "),
    (isViewMode.value && currentBookingType.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("label", { class: "form-label" }, " Nutzungsart ", -1 /* CACHED */)),
          _createElementVNode("input", {
            class: "form-control",
            value: currentBookingType.value.title,
            disabled: "",
            readonly: ""
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Title Field "),
    _createVNode(_unref(form).Field, {
      name: "title",
      validators: __props.titleValidator
    }, {
      default: _withCtx(({ field }) => [
        _createCommentVNode(" Only show title field if it has content in view mode, or always in edit/create mode "),
        (!isViewMode.value || (field.state.value && field.state.value.trim()))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("label", {
                for: "bookingTitle",
                class: "form-label"
              }, " Titel (öffentlich sichtbar) ", -1 /* CACHED */)),
              (!isViewMode.value)
                ? (_openBlock(), _createBlock(CharacterLimitedField, {
                    key: 0,
                    id: "bookingTitle",
                    name: field.name,
                    "model-value": field.state.value,
                    "max-length": _unref(TITLE_MAX_LENGTH),
                    placeholder: "Buchungstitel eingeben",
                    disabled: __props.disabled,
                    "onUpdate:modelValue": field.handleChange,
                    onBlur: field.handleBlur
                  }, null, 8 /* PROPS */, ["name", "model-value", "max-length", "disabled", "onUpdate:modelValue", "onBlur"]))
                : (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    class: "form-control",
                    value: field.state.value,
                    disabled: "",
                    readonly: ""
                  }, null, 8 /* PROPS */, _hoisted_5)),
              _createCommentVNode(" Validation errors (only in edit mode) "),
              (!isViewMode.value && field.state.meta.errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(field.state.meta.errors[0]), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["validators"]),
    _createCommentVNode(" Description Field "),
    _createVNode(_unref(form).Field, {
      name: "description",
      validators: __props.descriptionValidator
    }, {
      default: _withCtx(({ field }) => [
        _createCommentVNode(" Only show description field if it has content in view mode, or always in edit/create mode "),
        (!isViewMode.value || (field.state.value && field.state.value.trim()))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(userRole) === 'student' ? 'Beschreibung (nicht öffentlich sichtbar)' : 'Beschreibung'), 1 /* TEXT */),
              (!isViewMode.value)
                ? (_openBlock(), _createBlock(CharacterLimitedField, {
                    key: 0,
                    id: "bookingDescription",
                    name: field.name,
                    "model-value": field.state.value,
                    "max-length": _unref(DESCRIPTION_MAX_LENGTH),
                    multiline: "",
                    placeholder: "Optionale Beschreibung",
                    disabled: __props.disabled,
                    "onUpdate:modelValue": field.handleChange,
                    onBlur: field.handleBlur
                  }, null, 8 /* PROPS */, ["name", "model-value", "max-length", "disabled", "onUpdate:modelValue", "onBlur"]))
                : (_openBlock(), _createElementBlock("textarea", {
                    key: 1,
                    class: "form-control",
                    value: field.state.value,
                    rows: "2",
                    disabled: "",
                    readonly: ""
                  }, null, 8 /* PROPS */, _hoisted_9)),
              _createCommentVNode(" Validation errors (only in edit mode) "),
              (!isViewMode.value && field.state.meta.errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(field.state.meta.errors[0]), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["validators"])
  ]))
}
}

}